// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"e81d219d","594":"a7adc22b","745":"cfe1afec","762":"f241e78b","820":"a1ac3e91","935":"c8c9ad65"}[chunkId] + ".chunk.css";
};